import { errorCellRenderer } from "../components/flowTable";
import { FlowTableColumn } from "../components/flowTable/types";
import { PORT_OPERATORS } from "./types";

export const portColumns: FlowTableColumn[] = [
  {
    data: "operator",
    header: "Operador",
    type: "dropdown",
    source: PORT_OPERATORS,
    width: 120,
  },
  { data: "port", header: "Porta", type: "text", width: 160 },
];

export const portMassColumns: FlowTableColumn[] = portColumns.map((column) => ({
  ...column,
  ...(column.type === "dropdown" ? { allowInvalid: true } : {}),
  renderer: errorCellRenderer,
}));
